import { render } from "./copy-url.vue?vue&type=template&id=626beffa&scoped=true"
import script from "./copy-url.vue?vue&type=script&lang=js"
export * from "./copy-url.vue?vue&type=script&lang=js"

import "./copy-url.vue?vue&type=style&index=0&id=626beffa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626beffa"]])

export default __exports__